export default __webpack_public_path__ + "static/media/char_body_prem_015.618d7200.png";